module.exports = __webpack_public_path__ + "img/YuLoong.1819356b.svg";